import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { ReBaseData } from '../../utils/re-base-data';

@Component({
    selector: 'bdo-edit-card',
    templateUrl: './edit-card.component.html',
    styleUrls: ['./edit-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditCardComponent {
  @Input() isEditable: boolean = true;
  @Input() isDeletable: boolean = false;
  @Input() disabled: boolean = false;
  @Input() showFrame: boolean = true;
  @Output() edit: EventEmitter<boolean> = new EventEmitter();
  @Output() delete: EventEmitter<boolean> = new EventEmitter();
  protected reBaseData = ReBaseData;

  constructor() { }

  onEdit() {
    this.edit.emit(true);
  }

  onDelete() {
    this.delete.emit();
  }

}
